module.exports = __webpack_public_path__ + "static/media/thumb-fn.761be8ce.svg";